import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/stats/base/dists/truncated-normal/pdf';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace truncatedNormal
*/
var truncatedNormal = {};

/**
* @name pdf
* @memberof truncatedNormal
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/truncated-normal/pdf}
*/
setReadOnly( truncatedNormal, 'pdf', __var_1__);


// EXPORTS //
export default truncatedNormal;

export { __var_1__ as pdf};